module.exports = __webpack_public_path__ + "img/005.78d85707.png";